var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 223.228,
    height: 311.811,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    patternTransform: "rotate(-45 711.917 114.198)",
    id: "k",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("pattern", {
    id: "b",
    patternTransform: "translate(-254.024 74.426)",
    height: 110.741,
    width: 108.618,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1016.046 25.72l-10.764 16.121 7.177 18.006-18.658-5.255-14.907 12.39-.767-19.369-16.39-10.349 18.184-6.714 4.777-18.786 12.005 15.218z",
    transform: "translate(1070.355 -11.764)",
    fill: "#131f67"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(30 -588.091 2050.257)",
    d: "M-1016.046 25.72l-10.764 16.121 7.177 18.006-18.658-5.255-14.907 12.39-.767-19.369-16.39-10.349 18.184-6.714 4.777-18.786 12.005 15.218z",
    fill: "#131f67"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(1124.664 -11.764)",
    d: "M-1016.046 25.72l-10.764 16.121 7.177 18.006-18.658-5.255-14.907 12.39-.767-19.369-16.39-10.349 18.184-6.714 4.777-18.786 12.005 15.218z",
    fill: "#131f67"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(30 -560.936 2151.6)",
    d: "M-1016.046 25.72l-10.764 16.121 7.177 18.006-18.658-5.255-14.907 12.39-.767-19.369-16.39-10.349 18.184-6.714 4.777-18.786 12.005 15.218z",
    fill: "#131f67"
  })), /*#__PURE__*/React.createElement("pattern", {
    patternTransform: "scale(.15023) rotate(-45 922.96 6085.23)",
    id: "c",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("pattern", {
    patternTransform: "scale(.15023) rotate(-45 -2473.244 6852.978)",
    id: "d",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("pattern", {
    patternTransform: "scale(.15023) rotate(-45 227.657 -29.145)",
    id: "e",
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("pattern", {
    patternTransform: "scale(.15023) rotate(-45 730.249 525.163)",
    id: "f",
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("pattern", {
    patternTransform: "scale(.15023) rotate(-45 47.044 -1811.87)",
    id: "g",
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("pattern", {
    patternTransform: "matrix(.0652 -.0652 .0652 .0652 194.547 -74.73)",
    id: "h",
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("pattern", {
    patternTransform: "scale(.15565) rotate(-45 -238.81 2209.061)",
    id: "i",
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("pattern", {
    id: "j",
    patternTransform: "translate(-254.024 74.426)",
    height: 110.741,
    width: 108.618,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1016.046 25.72l-10.764 16.121 7.177 18.006-18.658-5.255-14.907 12.39-.767-19.369-16.39-10.349 18.184-6.714 4.777-18.786 12.005 15.218z",
    transform: "translate(1070.355 -11.764)",
    fill: "#d40000"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(30 -588.091 2050.257)",
    d: "M-1016.046 25.72l-10.764 16.121 7.177 18.006-18.658-5.255-14.907 12.39-.767-19.369-16.39-10.349 18.184-6.714 4.777-18.786 12.005 15.218z",
    fill: "#d40000"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(1124.664 -11.764)",
    d: "M-1016.046 25.72l-10.764 16.121 7.177 18.006-18.658-5.255-14.907 12.39-.767-19.369-16.39-10.349 18.184-6.714 4.777-18.786 12.005 15.218z",
    fill: "#d40000"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(30 -560.936 2151.6)",
    d: "M-1016.046 25.72l-10.764 16.121 7.177 18.006-18.658-5.255-14.907 12.39-.767-19.369-16.39-10.349 18.184-6.714 4.777-18.786 12.005 15.218z",
    fill: "#d40000"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "a",
    patternTransform: "translate(127.765 536.85)",
    height: 17.116,
    width: 16.772,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#d40000"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.62549 0 0 .62549 -79.915 -335.792)",
    d: "M139.931 538.17l-1.53 4.514 2.85 3.82-4.766-.06-2.753 3.891-1.415-4.552-4.552-1.415 3.892-2.752-.06-4.767 3.82 2.851z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.931 538.17l-1.53 4.514 2.85 3.82-4.766-.06-2.753 3.891-1.415-4.552-4.552-1.415 3.892-2.752-.06-4.767 3.82 2.851z",
    transform: "scale(.62549) rotate(60 542.293 175.25)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.931 538.17l-1.53 4.514 2.85 3.82-4.766-.06-2.753 3.891-1.415-4.552-4.552-1.415 3.892-2.752-.06-4.767 3.82 2.851z",
    transform: "matrix(.62549 0 0 -.62549 -79.915 352.908)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(.62549 -.62549) rotate(60 565.99 161.567)",
    d: "M139.931 538.17l-1.53 4.514 2.85 3.82-4.766-.06-2.753 3.891-1.415-4.552-4.552-1.415 3.892-2.752-.06-4.767 3.82 2.851z"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(550.942 -490.002)"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 10.63,
    ry: 10.63,
    y: 490.502,
    x: -550.442,
    height: 310.811,
    width: 222.228,
    fill: "#fff",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("rect", {
    ry: 0,
    y: 502.586,
    x: -537.854,
    height: 286.644,
    width: 197.052,
    fill: "none",
    stroke: "#d40000",
    strokeWidth: 4.952,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    stroke: "#d40000",
    strokeLinecap: "round",
    d: "M-533.467 506.455h188.277v278.906h-188.277z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedBack);
export default __webpack_public_path__ + "static/media/RED_BACK.df3220e6ab0f42a7c58ce760bc106ded.svg";
export { ForwardRef as ReactComponent };